import React from "react";
import moment from "moment";
import "../styles/components/apdex-chart.scss";

const ApdexTimeline = ({ datas, apdex, finalApdex, isToday }) => {
  var m = moment().utcOffset(0);
  m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const now = isToday ? moment() : m;
  return (
    <div className="apdex">
      <div className="numbers">
        <strong>{`${finalApdex}%`}</strong>
        <span>Apdex ({`${apdex} s`})</span>
      </div>
      <div className="history">
        <div className="apdex-timeline">
          {datas &&
            datas.map((data, index) => {
              const divStyle = {
                height: data ? `${data}%` : `0%`
              };
              let colorClass = "bad";
              if (data >= 90) {
                colorClass = "gold";
              } else if (data < 90 && data >= 75) {
                colorClass = "silver";
              } else if (data === null) {
                colorClass = "disable";
              }
              let jsx;
              if (index % 2 === 1) {
                jsx = (
                  <output key={index}>
                    <time
                      dateTime="2018-07-25T16:00:00Z"
                      className="ends-at"
                    >{`${now.add(2, "hours").format("HH:mm")}`}</time>
                    {data !== null ? (
                      <i className={colorClass} style={divStyle}>
                        <span>{parseInt(data)}</span>
                      </i>
                    ) : (
                      <i className={colorClass} style={divStyle} />
                    )}
                  </output>
                );
              } else {
                jsx = (
                  <output key={index}>
                    {data !== null ? (
                      <i className={colorClass} style={divStyle}>
                        <span>{parseInt(data)}</span>
                      </i>
                    ) : (
                      <i className={colorClass} style={divStyle} />
                    )}
                  </output>
                );
              }
              return jsx;
            })}
        </div>
      </div>
    </div>
  );
};

export default ApdexTimeline;
